import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useQuestionsList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: 'code', sortable: true, label: 'Código' },
        { key: 'question', sortable: true, label: 'Pregunta' },
        { key: 'question_type.name', sortable: true, label: 'Tipo de pregunta' },
        { key: 'actions', label: 'Opciones' }
    ];

    const perPage = ref(10);
    const totalUsers = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(false);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalUsers.value,
        }
    });

    const refetchData = () => {
        refUserListTable.value.refresh()
    };

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    });

    const fetchQuestions = (ctx, callback) => {
        store
            .dispatch('app-user/fetchQuestions', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { questions, total } = response.data;
                callback(questions);
                totalUsers.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista del banco de preguntas',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                });
            })
    };

    return {
        fetchQuestions,
        tableColumns,
        perPage,
        currentPage,
        totalUsers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,

        refetchData,
    }
}